import type { DtoMessage } from '@repo/api-types/order-retrieval';
import type { AssetDataType } from '@repo/types/asset';
import type { DraftMessage } from '@repo/types/draft';
import { type AssetMessage, isMessageAudience } from '@repo/types/messages';
import type { QuotationMessage } from '@repo/types/quotation';

import { getAssetData } from './customer-assets.selectors';

const selectMessagesFn = getAssetData(
    (data) => data.assetDetails.messages,
    (data) => data.assetDetails.cartData?.messages,
    (data) => data.assetDetails.cartData?.messages
);

export const selectMessages = (data?: AssetDataType, orderMessages?: AssetMessage[]): AssetMessage[] => {
    if (orderMessages !== undefined) {
        return orderMessages;
    }

    const messages = selectMessagesFn(data);

    if (!messages) {
        return [];
    }

    return normalizeData(messages);
};

const normalizeData = (messages: DtoMessage[] | DraftMessage[] | QuotationMessage[]): AssetMessage[] => {
    return messages.reduce<AssetMessage[]>((acc, message) => {
        const messageType = message.messageType;

        if (!isMessageAudience(messageType)) {
            return acc;
        }

        acc.push({
            messageText: message.messageText ?? '',
            messageType,
            createDateTime: message.createDateTime ?? '',
            createdUserId: message.createdUserId ?? '',
            orderMessageId: null,
        });

        return acc;
    }, []);
};
